import type { AuthUser, UserRole } from '../../types';

function decodeJwtPayload(token: string): Record<string, unknown> {
  try {
    const payload = token.split('.')[1] ?? '';
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), '=');
    const decoded = atob(padded);

    return JSON.parse(decoded) as Record<string, unknown>;
  } catch {
    throw new Error('Failed to decode auth token');
  }
}

export function extractUserFromIdToken(idToken: string): AuthUser {
  const payload = decodeJwtPayload(idToken);

  return {
    id: String(payload.sub ?? ''),
    username: payload['cognito:username'] ? String(payload['cognito:username']) : undefined,
    email: String(payload.email ?? ''),
    name: String(payload.name ?? payload.given_name ?? payload.email ?? 'User'),
    role: String(payload['custom:role'] ?? 'facilitator') as UserRole,
    companyId: payload['custom:companyId'] ? String(payload['custom:companyId']) : undefined,
  };
}
